import { useEffect, useState } from "react";

/**
 * Custom hook to detect browser tab visibility changes
 * Returns whether the current tab is visible
 */
export const useTabVisibility = (): { isVisible: boolean } => {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    // Initialize with current visibility state
    if (typeof document !== "undefined") {
      return !document.hidden;
    }
    return true;
  });

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    // Listen to visibility change events
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return { isVisible };
};

